module.exports = __webpack_public_path__ + "img/icon-question.cb19be7a.svg";